<section>
  <div class="container">
    <div class="row center-lg center-xs">
      <div class="col-lg-6 col-xs-12">
        @if (title()) {
          <app-title [titles]="[title()]" />
        }
        @if (data().text; as text) {
          <p class="paragraph">{{ text }}</p>
        }
      </div>
      <div class="col-lg-12 col-xs-12">
        @if (imagesDisplayed()) {
          <ul class="list">
            @for (item of imagesDisplayed(); track item.id) {
              <li class="item" id="img-{{ item.id }}">
                <app-image [image]="item" [size]="{ dw: 208, dh: 80, mw: 98, mh: 32 }" [isLoading]="false" />
              </li>
            }
          </ul>
        }
      </div>
    </div>
  </div>
</section>
